<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>GESTIÓN TRANSPORTE DE DESPACHOS</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="200" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <v-toolbar-title center>
                            <font color="green"> En Proceso de Gestión</font>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="mr-2" @click="editar(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <Editar :visible="showEditar" :codgral="editedItem.codgral" :codoc="editedItem.codoc"
                @close="showEditar = false">
            </Editar>

        </v-app>
    </div>
</template>


<script>
import axios from "../../axios-auth";
import Editar from "../Lanzamiento/Abastecimiento.vue";
import moment from "moment";

export default {
    components: { Editar },
    data: (vm) => ({
        usuario: "",
        editedItem: {
            fact: "",
            codgral: "",
            empresa: "",
            codoc: "",
            responsable: "",
        },
        editedIndex: -1,
        listado: [],
        showEditar: false,
        loadtable: false,
        headers: [
            { text: "N° de Cliente", value: "codgral", sortable: false },
            { text: "Nombre Empresa", value: "empresa", sortable: false },
            { text: "N° de Orden de Compra", value: "codoc", sortable: false },
            { text: "Provisión", value: "provision", sortable: false },
            { text: "Referente Proyecto", value: "lider", sortable: false },
            { text: "N° de OT", value: "numot", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],

    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            let self = this;
            axios
                .get("/Lanzamiento/Listadoabastecimiento?", {
                    params: {

                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        editar(item, flag) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>
